import { VisualizationUpdateLevel, Visualizer, VisualizerControl } from "../data-source/visualizer";
import { Timeline } from "../timeline/timeline";
import { Map as TLMDMap } from '../map/map';
import { ModelingContainer, ModelingVisualizerControl } from "./container-modeling";
import { ModelingDataSource } from "./modeling";
import { ModelingMapVisualizer } from "./mdl-mp-visualizer";
import { ModelingTimelineVisualizer } from "./mdl-tl-visualizer";
import { Drawer } from "../panel/cabinets";
import { delegatedObserver } from "../dom/dom";
import { ModelingInfoVisualizer } from "./mdl-ii-visualizer";

export class ModelingResultVisualizer implements Visualizer {
	private controls: { [key: string]: ModelingVisualizerControl }
	private inspectionContainer: ModelingContainer;
	private source: ModelingDataSource;

	private mapVisualizer: ModelingMapVisualizer;
	private timelineVisualizer: ModelingTimelineVisualizer;
	//private infoVisualizer: ModelingInfoVisualizer;

	public constructor(private visualizerKey: string, private mdlType: string, private drawer: Drawer, className: string) {
		this.mapVisualizer = new ModelingMapVisualizer('map', mdlType, drawer, `tlmd-modelproject_${mdlType}`);
		this.timelineVisualizer = new ModelingTimelineVisualizer('timeline', mdlType, drawer, `tlmd-modelproject_${mdlType}`);
//		this.infoVisualizer = new ModelingInfoVisualizer('info', mdlType, drawer );

	}
	public key(): string {
		return this.visualizerKey + '_' + this.type();
	}

	public type(): string {
		return this.mdlType;
	}

	public setControls(controls: { [key: string]: VisualizerControl }): Visualizer {
		this.controls = <{ [key: string]: ModelingVisualizerControl }>controls;

		let childVisualizerControls = controls? Object.keys(controls).reduce((childControls, type) => {
			childControls[type] = {
				enabled: (_visualizerKey: string) => this.controls[type].enabled(this.visualizerKey),
				setEnabled: (_visualizerKey: string, enabled: boolean) => this.controls[type].setEnabled(this.visualizerKey, enabled),
				animationMode: (_visualizerKey: string) => this.controls[type].animationMode(this.visualizerKey,),
				combineMode: (_visualizerKey: string) => this.controls[type].combineMode(this.visualizerKey),
				renderMode: (_visualizerKey: string) => this.controls[type].renderMode(this.visualizerKey),
				colorMode: (_visualizerKey: string) => this.controls[type].colorMode(this.visualizerKey),
				projectsToRender: () => this.controls[type].projectsToRender()
			}
			return childControls;
		}, <{ [key: string]: ModelingVisualizerControl }>{}) : undefined;


		this.mapVisualizer.setControls(childVisualizerControls);
		this.timelineVisualizer.setControls(childVisualizerControls);
//		this.infoVisualizer.setControls(childVisualizerControls);
		return this;
	}
	public release(): void {
		this.mapVisualizer.release();
		this.timelineVisualizer.release();
//		this.infoVisualizer.release();
	}
	public setMap(map: TLMDMap): void {
		this.mapVisualizer.setMap(map);
		this.timelineVisualizer.setMap(map);
//		this.infoVisualizer.setMap(map);
	}
	public setTimeline(timeline: Timeline): void {
		this.mapVisualizer.setTimeline(timeline);
		this.timelineVisualizer.setTimeline(timeline);
//		this.infoVisualizer.setTimeline(timeline);
	}
	public updateSelection(): void {
		this.mapVisualizer.updateSelection();
		this.timelineVisualizer.updateSelection();
//		this.infoVisualizer.updateSelection();
	}
	public refresh(level: VisualizationUpdateLevel): void {
		let combineMode;
		let renderMode;
		let colorMode;
		let projectsToRender;
		if (this.controls && this.controls[this.type()] && this.controls[this.type()].enabled(this.key())) {
			combineMode = this.controls[this.type()].combineMode(this.key());
			renderMode = this.controls[this.type()].renderMode(this.key());
			colorMode = this.controls[this.type()].colorMode(this.key());
			projectsToRender = this.controls[this.type()].projectsToRender();
		}
		this.mapVisualizer.updateMap(level, combineMode, renderMode, colorMode, projectsToRender);
		this.timelineVisualizer.updateTimeline(level, combineMode,projectsToRender);
//		this.infoVisualizer.refresh(level);
	}

}